import React from 'react'
import T from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { injectIntl } from 'react-intl'
import messages from './translate'

function ConfirmDialog({
  open,
  onClose,
  onConfirmAction,
  title,
  message,
  confirm,
  cancel,
  className,
  isSubmitDisabled,
  intl: { formatMessage },
}) {
  return (
    <Dialog
      fullWidth
      open={open}
      className={className}
      onClose={() => onClose(false)}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-message">
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-message">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(false)}
          className={cancel.color}
          variant={cancel.variant}>
          {cancel.customText ? cancel.customText : formatMessage(messages.no)}
        </Button>
        <Button
          disabled={isSubmitDisabled}
          onClick={() => onConfirmAction()}
          className={confirm.color}
          variant={confirm.variant}
          autoFocus>
          {confirm.customText
            ? confirm.customText
            : formatMessage(messages.yes)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmDialog.propTypes = {
  open: T.bool,
  onClose: T.func.isRequired,
  onConfirmAction: T.func.isRequired,
  title: T.string,
  message: T.node.isRequired,
  confirm: T.shape({
    color: T.string,
    variant: T.string,
    customText: T.any,
  }),
  cancel: T.shape({
    color: T.string,
    variant: T.string,
    customText: T.string,
  }),
}

ConfirmDialog.defaultProps = {
  open: false,
  title: 'Confirm',
  confirm: {
    color: 'scales-primary',
    variant: 'text',
    customText: '',
  },
  cancel: {
    color: 'scales-primary',
    variant: 'text',
    customText: '',
  },
}

export default injectIntl(ConfirmDialog)
